import { PaymentStatus } from '@apply/constants';
import { faCancel, faCheck, faClock, faRefresh } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface TimelineEntryParameters {
    paymentStatus: PaymentStatus;
    note: string;
    noteDate: Date;
}

export const TimelineEntry: React.FC<TimelineEntryParameters> = ({ paymentStatus, note, noteDate }) => {
    let icon = undefined;
    let className = undefined;

    switch (paymentStatus) {
        case PaymentStatus.InProgress:
            className = 'payment-icon-in-progress';
            icon = faClock;
            break;
        case PaymentStatus.RefundInProgress:
            className = 'payment-icon-refund-in-progress';
            icon = faClock;
            break;
        case PaymentStatus.Failure:
            className = 'payment-icon-failure';
            icon = faCancel;
            break;
        case PaymentStatus.RefundFailure:
            className = 'payment-icon-refund-failure';
            icon = faCancel;
            break;
        case PaymentStatus.Refund:
            className = 'payment-icon-refund';
            icon = faRefresh;
            break;
        case PaymentStatus.Success:
            className = 'payment-icon-success';
            icon = faCheck;
            break;
    }

    return (
        <div>
            {icon && (
                <FontAwesomeIcon
                    icon={icon}
                    size={'1x'}
                    className={className}
                />
            )}
            <span className='payment-edit-timeline-note'>{note}</span>
            <div className='payment-edit-timeline-date'>{dayjs(noteDate).format('MMMM D, YYYY, hh:mm a')} CT</div>
        </div>
    );
};
